const EARTH_RADIUS_MILES = 3958.8;

function toRadians(degrees) {
  return (degrees * Math.PI) / 180;
}

/**
 * Great-circle distance in miles between two coordinate points. Each point is
 * a { latitude, longitude } object. Returns null when either point is missing
 * or lacks coordinates so callers can hide the distance rather than render NaN.
 */
function haversineDistance(from, to) {
  if (!from || !to || from.latitude == null || from.longitude == null || to.latitude == null || to.longitude == null) {
    return null;
  }

  const deltaLatitude = toRadians(to.latitude - from.latitude);
  const deltaLongitude = toRadians(to.longitude - from.longitude);

  const a = (Math.sin(deltaLatitude / 2) ** 2)
    + (Math.cos(toRadians(from.latitude)) * Math.cos(toRadians(to.latitude)) * (Math.sin(deltaLongitude / 2) ** 2));

  return EARTH_RADIUS_MILES * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
}

export default haversineDistance;
